import { render } from "./Page-AnalyseSchemas.vue?vue&type=template&id=f40a93da&scoped=true"
import script from "./Page-AnalyseSchemas.vue?vue&type=script&lang=js"
export * from "./Page-AnalyseSchemas.vue?vue&type=script&lang=js"

import "./Page-AnalyseSchemas.vue?vue&type=style&index=0&id=f40a93da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40a93da"]])

export default __exports__